// extracted by mini-css-extract-plugin
export default {"formWithOutTopMargin":"SecurityRoleViewPage_formWithOutTopMargin__tC74u"};